export default __webpack_public_path__ + "static/media/book-removebg-preview.2d5e80b6.png";